// @ts-strict-ignore
import { Button, Card, Flex, Text, mediaQuery } from "@hubble/web";
import styled from "styled-components";

export const HowToBuyRedirectCardContainer = styled(Card)`
  position: relative;
  min-height: 288px;
  grid-area: 3 / 1 / 6 / 3;

  background-image: url("https://images.ctfassets.net/jg6lo9a2ukvr/5g82NhyMb62fUliL3XYnXj/081d07a13e6d1ddceea4256d36ca7c2c/Mask_group.png?fm=webp");
  background-size: cover;
  background-position: center;

  @media ${mediaQuery.mobileXsDown} {
    background-image: url("https://images.ctfassets.net/jg6lo9a2ukvr/6KVSpJuk0BZjxWCwVsaB0n/2a21dc7cff2364aba70b3157d84b6b7f/Priceconverter_iphone_Mobile.png?fm=webp");
    grid-area: 5 / 1 / 7 / -1;
  }
`;

export const HowToBuyRedirectCardContent = styled(Flex)`
  flex-direction: column;
  gap: 25px;
`;

export const HowToBuyRedirectText = styled(Text.Heading)`
  max-width: 286px;
`;

export const HowToBuyRedirectButton = styled(Button.Primary)`
  width: max-content;
`;
